import { useForm } from "react-hook-form";
import { useState, useEffect, useContext, useRef } from "react";
import { AppContext } from "../Main";
import Breakdown from "../formParts/Breakdown";
import OneHourHomeVisitInfo from "../formParts/OneHourHomeVisitInfo";
import Loader from "../UI/Loader";
import prebuildData from "../../data.json";
import { ONE_HOUR_HOME_VISIT } from "../../utils/utils";

export default function OneHourHomeVisit() {
  const {
    setForm,
    setFormType,
    setServiceData,
    step,
    setStep,
    setForwardStep,
    setBackStep,
    setForwardStepTitle,
    breakdown,
    setBreakdown,
    formDefaultValues,
    setFormDefaultValues,
    setCustomerDetails,
  } = useContext(AppContext);

  //useState to store endpoint data
  const [simProData, setSimProData] = useState({
    firstHour: [],
  });

  // state to manage loading of data from SimPro
  const [loaded, setLoaded] = useState(false);

  // React Hook Form
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: formDefaultValues ? formDefaultValues : {},
  });

  const formRef = useRef();

  useEffect(() => setFormType(ONE_HOUR_HOME_VISIT));

  useEffect(() => {
    if (formDefaultValues) {
      // Form has been submitted so user has navigated back from after form submission
      setStep(1);
      setBackStep(() => () => setStep(0));
      setForwardStep(() => () => setForm(9));
    }
  }, [formDefaultValues]);

  useEffect(() => {
    setForwardStepTitle("Next");
    setBackStep(undefined);
    switch (step) {
      case 0:
        setBackStep(undefined);
        setForwardStepTitle("Get my quote");
        setForwardStep(
            () => () =>
              formRef.current.dispatchEvent(
                new Event("submit", { cancelable: true, bubbles: true })
              )
          );
        break;
      case 1:
        setBackStep(() => () => setStep(0));
        setForwardStep(() => () => setForm(9));
        break;
      default:
        break;
    }
  }, [
    setBackStep,
    setForm,
    setForwardStep,
    setForwardStepTitle,
    setStep,
    step,
  ]);

  // fetch data from SimPro
  useEffect(() => {
    prebuildData.forEach((prebuild) => {
      if (prebuild.ID === 165498) { // One Hour Home Visit Prebuild ID
        setSimProData((prevState) => ({
          ...prevState,
          firstHour: prebuild,
        }));
      }
    });
    setLoaded(true);
  }, []);

  const onSubmit = (data) => {
    function calculateTotals() {
        let breakdown = [];

        breakdown.push({
            name: "First Hour Charge",
            qty: 1,
            price: simProData?.firstHour.TotalEx,
            time: simProData?.firstHour?.LaborTime,
            prebuildIds: [simProData?.firstHour.ID],
        });

        return breakdown;
    }

    setBreakdown(calculateTotals());
    setStep(1);
    setServiceData({
      isRewiring: false,
      data,
      breakdown: calculateTotals(),
    });
    setFormDefaultValues(data);
    // Store customerNotes in customerDetails so it can be pre-filled in InfoForm
    if (data.customerNotes) {
      setCustomerDetails({ customerNotes: data.customerNotes });
    }
  };

  //Conditional component to switch between journey steps
  const conditionalComponent = () => {
      switch (step) {
        case 0:
          return (
            <OneHourHomeVisitInfo
              register={register}
              watch={watch}
              setValue={setValue}
              errors={errors}
            />
          );
        case 1:
          return (
            <Breakdown
              formName={ONE_HOUR_HOME_VISIT}
              breakdown={breakdown}
              watch={watch}
            />
          );
        default:
          return <OneHourHomeVisitInfo register={register} />;
      }
    };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
        {/* Component switcher */}
        {loaded ? conditionalComponent() : <Loader />}
      </form>
    </div>
  );
}
